import { FiAperture, FiBookmark, FiBox, FiCheckCircle, FiCoffee, FiDribbble, FiFacebook, FiInstagram, FiLinkedin, FiMessageCircle, FiSend, FiStar, FiTwitter, FiUser, FiUserCheck } from "react-icons/fi";

import team1 from '../assets/images/team/1.jpg'
import team2 from '../assets/images/team/2.jpg'
import team3 from '../assets/images/team/3.jpg'
import team4 from '../assets/images/team/4.jpg'
import team5 from '../assets/images/team/5.jpg'
import team6 from '../assets/images/team/6.jpg'
import team7 from '../assets/images/team/7.jpg'
import team8 from '../assets/images/team/8.jpg'

import blog1 from '../assets/images/blog/1.jpg'
import blog2 from '../assets/images/blog/2.jpg'
import blog3 from '../assets/images/blog/3.jpg'
import blog4 from '../assets/images/blog/4.jpg'
import blog5 from '../assets/images/blog/5.jpg'
import blog6 from '../assets/images/blog/6.jpg'
import blog7 from '../assets/images/blog/7.jpg'
import blog8 from '../assets/images/blog/8.jpg'
import blog9 from '../assets/images/blog/9.jpg'

import project1 from '../assets/images/projects/1.jpg'
import project2 from '../assets/images/projects/2.jpg'
import project3 from '../assets/images/projects/3.jpg'
import project4 from '../assets/images/projects/4.jpg'
import project5 from '../assets/images/projects/5.jpg'
import project6 from '../assets/images/projects/6.jpg'

export const featureData = [
    {
        icon:FiAperture,
        title:'Branding Strategy',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiSend,
        title:'Digital Solutions',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiUser,
        title:'Social Media',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiStar,
        title:'Insightful Analytics',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiBookmark,
        title:'Business Consultation',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiMessageCircle,
        title:'24/7 Support',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
]

export const clientData = [
    {
        image:team1,
        name:'Calvin Carlo',
        position:'Manager',
        desc:"According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero Launch your campaign and benefit from our expertise",
        tag:'Creativity',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team2,
        name:'Carl Oliver',
        position:'Manager',
        desc:"I didn't know a thing about icon design until I read this book. Now I can create any icon I need in no time. Great resource!",
        tag:'Modern',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team3,
        name:'Barbara McIntosh',
        position:'Manager',
        desc:"The best part about Flipup is every time I pay my employees, my bank balance doesn't go down like it used to. Looking forward to spending this extra cash when I figure out why my card is being declined.",
        tag:'Social Marketing',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team4,
        name:'Janisha Doll',
        position:'Manager',
        desc:"I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though",
        tag:'Digital Marketing',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team5,
        name:'Esther Howard',
        position:'Manager',
        desc:"There are so many things I had to do with my old software that I just don't do at all with Flipup. Suspicious but I can't say I don't love it",
        tag:'SEO',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team6,
        name:'Joshua William',
        position:'Manager',
        desc:"I'm trying to get a hold of someone in support, I'm in a lot of trouble right now and they are saying it has something to do with my books. Please get back to me right away.",
        tag:'Classic',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team7,
        name:'Thomas Israel',
        position:'Manager',
        desc:"This is the fourth email I've sent to your support team. I am literally being held in jail for tax fraud. Please answer your damn emails, this is important. ",
        tag:'Features',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team8,
        name:'Jill Webb',
        position:'Manager',
        desc:"I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though. ",
        tag:'Branding',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:team2,
        name:'Jennifer White',
        position:'Manager',
        desc:"The team is exceptional. Their passion for what they do is evident in the results they deliver. We're grateful to have them as a trusted partner in our journey. ",
        tag:'Product Design',
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        tag:'Eloza',
        title:'Utilizing mobile technology in the field',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'13th Sept 2024'
    },
    {
        id:2,
        image:blog2,
        tag:'Eloza',
        title:'Success Story: Businessman in Harlem',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'29th Nov 2024'
    },
    {
        id:3,
        image:blog3,
        tag:'Eloza',
        title:'How Does Marketing Automation Help Lead',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'29th Desc 2024'
    },
    {
        id:4,
        image:blog4,
        tag:'Eloza',
        title:"Working from home? Let's get started.",
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'13th March 2024'
    },
    {
        id:5,
        image:blog5,
        tag:'Eloza',
        title:'The Ultimate Success Formula - How?',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'5th May 2024'
    },
    {
        id:6,
        image:blog6,
        tag:'Eloza',
        title:'The Major Differences Between SEO & Local SEO',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'19th June 2024'
    },
    {
        id:7,
        image:blog7,
        tag:'Eloza',
        title:'Building intelligent transportation systems',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'20th June 2024'
    },
    {
        id:8,
        image:blog8,
        tag:'Eloza',
        title:'12 Questions to Ask Before Hiring a SEO Agency',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'31st Aug 2024'
    },
    {
        id:9,
        image:blog9,
        tag:'Eloza',
        title:'How a Social Media Audit Can Help You',
        desc:"Success needs hard work. Don't listen to these 'get rich quick' schemes.",
        date:'1st Sept 2024'
    },
]

export const footerSocial = [
    {
        icon:FiDribbble,
        link:'https://dribbble.com/shreethemes'
    },
    {
        icon:FiLinkedin,
        link:'http://linkedin.com/company/shreethemes'
    },
    {
        icon:FiFacebook,
        link:'https://www.facebook.com/shreethemes'
    },
    {
        icon:FiInstagram,
        link:'https://www.instagram.com/shreethemes'
    },
    {
        icon:FiTwitter,
        link:'https://twitter.com/shreethemes'
    },
]

export const footerCompany = [
    {
        title:'About us',
        link:'/aboutus'
    },
    {
        title:'Services',
        link:'/services'
    },
    {
        title:'Team',
        link:'/team'
    },
    {
        title:'Pricing',
        link:'/pricing'
    },
    {
        title:'Blog',
        link:'/blogs'
    },
    {
        title:'Login',
        link:'/login'
    },
]

export const footerLink = [
    {
        title:'Helpcenter',
        link:'/faqs'
    },
    {
        title:'Terms of Services',
        link:'/terms'
    },
    {
        title:'Privacy Policy',
        link:'/privacy'
    },
]

export const footerLink2 = [
    'Privacy','Terms','FAQs','Contact'
]

export const counterData = [
    {
        icon:FiCheckCircle,
        title:'Project Completed',
        value:'49'
    },
    {
        icon:FiCoffee,
        title:'Cup of Coffee',
        value:'2461'
    },
    {
        icon:FiUserCheck,
        title:'Client Satisfaction',
        value:'99'
    },
    {
        icon:FiBox,
        title:'Country Offices',
        value:'49'
    },
]

export const teamData = [
    {
        image:team1,
        name:'Jack John',
        position:'Founder & CEO',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team2,
        name:'Jeremiah Green',
        position:'CTO',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team3,
        name:'Christin Vasquez',
        position:'Developer',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team4,
        name:'Lillian Boldt',
        position:'Product Manager',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team5,
        name:'Krista John',
        position:'Creative Director',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team6,
        name:'Ricky Peters',
        position:'Market Researcher',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team7,
        name:'Roger Jackson',
        position:'Marketing Expert',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
    {
        image:team8,
        name:'Camille Smith',
        position:'Director of HR',
        social:[FiFacebook,FiInstagram,FiTwitter]
    },
]

export const servicesData = [
    {
        icon:FiAperture,
        title:'Branding Strategy',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiSend,
        title:'Digital Solutions',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiUser,
        title:'Social Media',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiStar,
        title:'Insightful Analytics',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiBookmark,
        title:'Business Consultation',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
    {
        icon:FiMessageCircle,
        title:'24/7 Support',
        desc:"Design better and spend less time without restricting creative freedom. Combine layouts, customize everything"
    },
]

export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use Eloza ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]

export const recentPost = [
    {
        image:blog1,
        title:'Consultant Business',
        date:'13th March 2024'
    },
    {
        image:blog2,
        title:'Grow Your Business',
        date:'5th May 2024'
    },
    {
        image:blog3,
        title:'Look On The Glorious Balance',
        date:'19th June 2024'
    },
]

export const tagCloud =[
    'Business','Finance','Marketing','Fashion','Bride','Lifestyle','Travel','Beauty','Video','Audio',
]

export const tearmsData = [ 
    'Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand','Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand'
]

export const projectData = [
    {
        image:project1,
        title:'Artboard Studio',
        subTitle:'Custom Branding'
    },
    {
        image:project2,
        title:'The Portrait',
        subTitle:'Custom Branding'
    },
    {
        image:project3,
        title:'Villa in Dallas',
        subTitle:'Custom Branding'
    },
    {
        image:project4,
        title:'Photo Retouching',
        subTitle:'Custom Branding'
    },
    {
        image:project5,
        title:'Mercedez-Benz Coupe',
        subTitle:'Custom Branding'
    },
    {
        image:project6,
        title:'Inspiration Board',
        subTitle:'Custom Branding'
    },
]